import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as adminService from '../lib/services/adminService';
import './Banner.css';

const Banner = () => {
  const location = useLocation();
  const [message, setMessage] = useState('');
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    isMobile: window.innerWidth <= 480,
    isTablet: window.innerWidth > 480 && window.innerWidth <= 1024,
    isDesktop: window.innerWidth > 1024
  });

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        width,
        isMobile: width <= 480,
        isTablet: width > 480 && width <= 1024,
        isDesktop: width > 1024
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const data = await adminService.getCompanyInfo();
        if (data?.banner_message) {
          setMessage(data.banner_message);
        }
      } catch (err) {
        console.error('Error fetching banner message:', err);
      }
    };

    fetchBanner();
  }, []);

  // Hide on admin routes
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  if (!message) return null;

  // Truncate message for mobile devices if too long
  const getDisplayMessage = () => {
    if (screenSize.isMobile && message.length > 60) {
      return message.substring(0, 57) + '...';
    } else if (screenSize.isTablet && message.length > 100) {
      return message.substring(0, 97) + '...';
    }
    return message;
  };

  return (
    <div className="global-banner">
      <div className="banner-track">
        <div className={`banner-text ${screenSize.isMobile ? 'mobile' : screenSize.isTablet ? 'tablet' : 'desktop'}`}>
          {getDisplayMessage()}
        </div>
      </div>
    </div>
  );
};

export default Banner;
